var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearchPlaceholder(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 300,
    height: 287.112,
    viewBox: "0 0 300 287.112",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_13",
    "data-name": "Group 13",
    transform: "translate(-380 -220)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_42",
    "data-name": "Path 42",
    d: "M-615.342-1134.452H-798.394v-131.333l5.7-13.614h66.55l5.7,13.614h105.109Z",
    transform: "translate(1255.241 1589.802)",
    fill: "#eff0f2",
    stroke: "#ced3d7",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2",
    "data-name": "Ellipse 2",
    cx: 78.14,
    cy: 78.034,
    rx: 78.14,
    ry: 78.034,
    transform: "translate(419.654 246.631)",
    fill: "#324049",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44",
    "data-name": "Path 44",
    d: "M1.294,0l25.3.017a1.3,1.3,0,0,1,1.3,1.3l.066,101.5a1.293,1.293,0,0,1-1.294,1.294l-25.3-.017a1.3,1.3,0,0,1-1.3-1.3L0,1.294A1.293,1.293,0,0,1,1.294,0Z",
    transform: "translate(556.684 422.868) rotate(-37.908)",
    fill: "#eff0f2",
    stroke: "#ced3d7",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45",
    "data-name": "Path 45",
    d: "M0,0,27.89.018l0,3.643L0,3.643Z",
    transform: "translate(563.087 431.081) rotate(-37.908)",
    fill: "#ced3d7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46",
    "data-name": "Path 46",
    d: "M0,0,27.89.018l0,3.643L0,3.643Z",
    transform: "translate(611.948 493.743) rotate(-37.908)",
    fill: "#ced3d7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47",
    "data-name": "Path 47",
    d: "M0,0,14.565.01l.023,35.316L.023,35.316Z",
    transform: "translate(540.14 390.817) rotate(-37.908)",
    fill: "#eff0f2",
    stroke: "#ced3d7",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43",
    "data-name": "Path 43",
    d: "M-661.626-1156.522a86.5,86.5,0,0,1-11.045,10.244A84.954,84.954,0,0,1-735.7-1128.93a84.893,84.893,0,0,1-56.855-32.245,84.671,84.671,0,0,1-17.368-62.948,84.722,84.722,0,0,1,32.286-56.775,84.937,84.937,0,0,1,63.033-17.349A84.881,84.881,0,0,1-657.757-1266a84.651,84.651,0,0,1,17.372,62.944A84.649,84.649,0,0,1-661.626-1156.522Zm-116.223-104.4a70.218,70.218,0,0,0-17.62,38.6,70.237,70.237,0,0,0,14.407,52.209,70.422,70.422,0,0,0,47.156,26.743,70.461,70.461,0,0,0,52.283-14.388,70.289,70.289,0,0,0,26.78-47.092,70.238,70.238,0,0,0-14.411-52.208,70.4,70.4,0,0,0-47.152-26.744,70.457,70.457,0,0,0-52.283,14.388A71.693,71.693,0,0,0-777.85-1260.92Z",
    transform: "translate(1222.951 1538.253)",
    fill: "#eff0f2",
    stroke: "#ced3d7",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_3",
    "data-name": "Ellipse 3",
    cx: 4.235,
    cy: 4.229,
    rx: 4.235,
    ry: 4.229,
    transform: "translate(422.694 438.714)",
    fill: "#dee1e5"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_4",
    "data-name": "Ellipse 4",
    cx: 4.235,
    cy: 4.229,
    rx: 4.235,
    ry: 4.229,
    transform: "translate(380 301.944)",
    fill: "#dee1e5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3876",
    "data-name": "Rectangle 3876",
    width: 1.063,
    height: 6.372,
    rx: 0.146,
    transform: "translate(520.574 220)",
    fill: "#bdc4ca"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3877",
    "data-name": "Rectangle 3877",
    width: 1.062,
    height: 6.38,
    rx: 0.146,
    transform: "translate(524.295 222.654) rotate(90)",
    fill: "#bdc4ca"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_5",
    "data-name": "Ellipse 5",
    cx: 2.118,
    cy: 2.115,
    rx: 2.118,
    ry: 2.115,
    transform: "translate(624.076 299.315)",
    fill: "#dee1e5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3878",
    "data-name": "Rectangle 3878",
    width: 1.063,
    height: 6.372,
    rx: 0.146,
    transform: "translate(676.278 423.957)",
    fill: "#bdc4ca"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3879",
    "data-name": "Rectangle 3879",
    width: 1.062,
    height: 6.38,
    rx: 0.146,
    transform: "translate(680 426.612) rotate(90)",
    fill: "#bdc4ca"
  }), /*#__PURE__*/React.createElement("text", {
    id: "Nothing_to_see_here",
    "data-name": "Nothing to see here",
    transform: "translate(459.98 315.474)",
    fill: "#adb5bd",
    fontSize: 4,
    fontFamily: "Lato-Bold, Lato",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 18,
    y: 4
  }, "Nothing to see here")))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchPlaceholder);
export default __webpack_public_path__ + "static/media/search-placeholder.d52e76838c490aa14dab2767c5750bb9.svg";
export { ForwardRef as ReactComponent };